"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameBrandDetails = exports.useUserBrandDetails = exports.useBrandDetails = exports.loadBrandDetails = void 0;
var react_1 = __importDefault(require("react"));
var types_1 = require("@pose-party/types");
var firebase_1 = __importDefault(require("./firebase"));
var loadBrandDetails = function (_a, onSnapshot) {
    var brandId = _a.brandId;
    var snapshotUnsubscribe = firebase_1.default()
        .firestore()
        .collection("brands")
        .doc(brandId)
        .onSnapshot(function (doc) {
        // Reject if the document does not exist
        if (!doc.exists) {
            onSnapshot(null);
            return;
        }
        var brandDetails = __assign(__assign({}, types_1.defaultBrandDetails({ brandId: brandId })), (doc.data() || {}));
        // Reject if there is missing brand information
        if (!brandDetails.domain || !brandDetails.name || !brandDetails.colors) {
            onSnapshot(null);
            return;
        }
        // Reject if any brand colors are missing
        if (!brandDetails.colors.primaryBrand ||
            !brandDetails.colors.primaryBrandOverlay ||
            !brandDetails.colors.secondaryBrand ||
            !brandDetails.colors.secondaryBrandOverlay ||
            !brandDetails.colors.background ||
            !brandDetails.colors.backgroundOverlay ||
            !brandDetails.colors.headerBackground ||
            !brandDetails.colors.headerBackgroundOverlay ||
            !brandDetails.colors.footerBackground ||
            !brandDetails.colors.footerBackgroundOverlay ||
            !brandDetails.colors.textInputBackground ||
            !brandDetails.colors.textInputBackgroundOverlay ||
            !brandDetails.colors.desktopBackground) {
            onSnapshot(null);
            return;
        }
        onSnapshot(brandDetails);
    });
    return snapshotUnsubscribe;
};
exports.loadBrandDetails = loadBrandDetails;
var useBrandDetails = function (_a) {
    var brandId = _a.brandId, defaultValue = _a.defaultValue;
    var _b = react_1.default.useState(defaultValue), brandDetails = _b[0], setBrandDetails = _b[1];
    react_1.default.useEffect(function () {
        var snapshotUnsubscribe = exports.loadBrandDetails({
            brandId: brandId,
        }, function (newBrandDetails) { return setBrandDetails(newBrandDetails); });
        return snapshotUnsubscribe;
    }, [brandId]);
    return brandDetails;
};
exports.useBrandDetails = useBrandDetails;
var useUserBrandDetails = function (_a) {
    var brandId = _a.brandId, uid = _a.uid;
    var _b = react_1.default.useState(), brandDetails = _b[0], setBrandDetails = _b[1];
    react_1.default.useEffect(function () {
        if (!uid) {
            setBrandDetails(undefined);
            return;
        }
        var documentRef = firebase_1.default()
            .firestore()
            .collection("brands")
            .doc(brandId)
            .collection("userBrandDetails")
            .doc(uid);
        return documentRef.onSnapshot(function (data) {
            setBrandDetails(data.data() || {});
        });
    }, [brandId, uid]);
    return brandDetails;
};
exports.useUserBrandDetails = useUserBrandDetails;
var useGameBrandDetails = function (_a) {
    var brandId = _a.brandId, gameId = _a.gameId;
    var _b = react_1.default.useState(), brandDetails = _b[0], setBrandDetails = _b[1];
    react_1.default.useEffect(function () {
        if (!gameId) {
            setBrandDetails(undefined);
            return;
        }
        var documentRef = firebase_1.default()
            .firestore()
            .collection("brands")
            .doc(brandId)
            .collection("gameBrandDetails")
            .doc(gameId);
        return documentRef.onSnapshot(function (data) {
            setBrandDetails(data.data() || {});
        });
    }, [brandId, gameId]);
    return brandDetails;
};
exports.useGameBrandDetails = useGameBrandDetails;
//# sourceMappingURL=brand.js.map